module.exports = __webpack_public_path__ + "media/images/hero_images/brand-1439-e7a9f0accdaef62d47dcf5a1f0721f71.jpg";